var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 25.1522C3.63281 13.2321 13.296 3.56885 25.2161 3.56885C37.1362 3.56885 46.7995 13.2321 46.7995 25.1522C46.7995 37.0723 37.1362 46.7355 25.2161 46.7355C13.296 46.7355 3.63281 37.0723 3.63281 25.1522ZM25.2161 7.06885C15.229 7.06885 7.13281 15.1651 7.13281 25.1522C7.13281 35.1393 15.229 43.2355 25.2161 43.2355C35.2033 43.2355 43.2995 35.1393 43.2995 25.1522C43.2995 15.1651 35.2033 7.06885 25.2161 7.06885Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4661 25.1522C16.4661 26.1187 17.2496 26.9022 18.2161 26.9022H32.2161C33.1826 26.9022 33.9661 26.1187 33.9661 25.1522C33.9661 24.1857 33.1826 23.4022 32.2161 23.4022H18.2161C17.2496 23.4022 16.4661 24.1857 16.4661 25.1522Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2375 38.1735C38.9209 37.4901 40.0289 37.4901 40.7124 38.1735L50.6119 48.073C51.2953 48.7564 51.2953 49.8645 50.6119 50.5479C49.9285 51.2313 48.8204 51.2313 48.137 50.5479L38.2375 40.6484C37.5541 39.965 37.5541 38.8569 38.2375 38.1735Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoom-out.1bb932a1.svg";
export { ForwardRef as ReactComponent };